import DriveCharge, { PAGE_TYPE } from '@elem/compCommon/DriveCharge';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import P from './components/P';
import R from './components/R';
import { BundleList } from '@/components/ProductCommon/bundle-list';
import { useGlobal } from '@/utils/useGlobal';
import IRAFooter from '@/components/IRAComp/IRAFooterNew';
import AppPointDeltaAdv from '@/components/AppPoint/DeltaAdvPC';
import { SHOW_APP_POINT_SITES } from '@/constants';
import OtherList from '@/components/ProductCommon/OtherList';
import { getDetaileMoreProducts } from '@/utils';

const BundleLists: any = {
    us: ['d2m220', 'd2m400', 'd2mWave2'],
    ca: ['d2m220', 'd2m400', 'd2mWave2'],
    eu: ['d2mEB', 'd2m220', 'd2m400'],
    uk: ['d2mEB', 'd2m220', 'd2m400'],
    de: ['d2mEB', 'd2m220', 'd2m400'],
    fr: ['d2mEB', 'd2m220', 'd2m400'],
    it: ['d2mEB', 'd2m220', 'd2m400'],
    es: ['d2mEB', 'd2m220', 'd2m400'],
    jp: ['d2mWave2', 'd2m220', 'd2mEB'],
    br: ['r2110', 'd2220', 'dp400'],
    ph: ['d2m220', 'd2m400', 'd2mPS'],
};

export default function IndexDynamic({}: any) {
    const { useRouter, gloproductlist } = useGlobal();
    const { locale } = useRouter();
    const product: any = {
        us: ['product_ps_delta_delta_3_s', 'product_ps_river_river_pro_720', 'product_ps_delta_delta_pro'],
        mx: ['product_ps_delta_delta_3_s', 'product_ps_river_703', 'product_ps_delta_delta_pro'],
    };
    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            {/* <J /> */}
            <K />
            <DriveCharge locale={locale} pageType={PAGE_TYPE.DELTA_2_MAX} theme="white" />
            <L />
            <M />
            <N />
            {!SHOW_APP_POINT_SITES.includes(locale) && <O />}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointDeltaAdv />}
            <P />
            {/* <Q /> */}
            <R />
            {/* <S /> */}
            {locale === 'us' && (
                <IRAFooter
                    borderTopColor="transparent"
                    bgColor="transparent"
                    titleColor="#000"
                    descColor="#000"
                    boxStyle={{ margin: '0 auto 90px', width: '1120px' }}
                />
            )}
            {!['sa', 'za', 'tw', 'mx'].includes(locale) && (
                <div className="delta2-otherlist">
                    <BundleList
                        list={BundleLists[locale] || BundleLists.us}
                        moreUrl={
                            ['br'].includes(locale)
                                ? 'https://br.ecoflow.com/collections/delta-solar-generators'
                                : `https://${locale}.ecoflow.com/collections/smart-devices`
                        }
                        theme="grey"
                    />
                </div>
            )}
            {['mx'].includes(locale) && (
                <OtherList
                    data={getDetaileMoreProducts(
                        gloproductlist,
                        product[locale] || product.us,
                        '',
                        '',
                        `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                    )}
                />
            )}
        </>
    );
}
